var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#D1C8B9;}\n\t.st1{fill:#E5DFD7;}\n\t.st2{fill:#BDB09B;}\n\t.st3{fill:#F2EFEB;}\n\t.st4{clip-path:url(#SVGID_2_);fill:#003E7E;}\n\t.st5{fill:#003E7E;}\n\t.st6{clip-path:url(#SVGID_4_);fill:#003E7E;}\n\t.st7{clip-path:url(#SVGID_6_);fill:#003E7E;}\n");

var _ref3 = /*#__PURE__*/React.createElement("polyline", {
  className: "st0",
  points: "229.7,155 229.7,111.5 456.2,67.8 459.4,125.9 "
});

var _ref4 = /*#__PURE__*/React.createElement("polyline", {
  className: "st1",
  points: "229.7,155 229.7,111.5 2.6,67.8 2.6,125.9 "
});

var _ref5 = /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "232.3,353.5 229.7,487.4 2.6,382.6 "
});

var _ref6 = /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "232.3,427.8 462,382.6 232.3,353.5 "
});

var _ref7 = /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "309,96.3 229.7,111.5 88.8,88.8 149.3,67.8 "
});

var _ref8 = /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "155.3,0 155.3,80.7 260,96.3 458.6,125.9 455.8,67.9 "
});

var _ref9 = /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "155.3,0 1.4,67.9 0,125.9 101.6,96.3 155.3,80.7 "
});

var _ref10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_1_",
  width: 462,
  height: 669.8
}));

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M126.1,346.8l32.8-55.6h-41.4l-9,16.6c-6.3,11.8-15.1,28.4-19.7,39.8c0.4-11.6,0.7-24.5,0.7-38.5v-17.9h-37 v153.2h37v-51l9.2-13.3l22.1,64.3h40.9L126.1,346.8z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M229,368c0,37-5.7,47.3-17.1,47.3s-17.3-10.7-17.3-47.7s5.5-47.3,17.1-47.3C223.1,320.3,229,331,229,368  M266.6,367.5c0-53.8-20.4-78.8-54.7-78.8c-34.4,0-54.9,25.2-54.9,79.2s20.1,78.8,54.5,78.8C246.1,446.8,266.6,421.6,266.6,367.5"
});

var _ref13 = /*#__PURE__*/React.createElement("polygon", {
  className: "st5",
  points: "366.4,302 267.7,302 267.7,333.9 298.8,333.9 298.8,455.2 335.3,455.2 335.3,333.9 366.4,333.9 "
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 379.5,
  y: 291.2,
  className: "st5",
  width: 37,
  height: 153.2
});

var _ref15 = /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "5.9,556.7 157,669.8 157,427.8 1.7,382.6 "
});

var _ref16 = /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "157,427.8 157,669.8 453.8,556.7 462,382.6 "
});

var _ref17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_3_",
  width: 462,
  height: 669.8
}));

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M128.6,256.5c-9.7,0-14.8-9.2-14.8-40.8s4.7-40.5,14.6-40.5c9.7,0,14.8,9.2,14.8,40.8 C143.2,247.7,138.3,256.5,128.6,256.5 M128.6,148.2c-29.4,0-47,21.5-47,67.8c0,46.3,17.2,67.4,46.6,67.4 c29.6,0,47.2-21.5,47.2-67.8C175.4,169.6,158,148.2,128.6,148.2"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M273,124.7l-28.7,2.5l-8.8,33.6c-4.5,16.9-8.1,32.7-9.2,42.2c-2.5-9.2-9.1-24.5-16.1-39.8l-14.7-31.7 l-28.9,2.5l11.7,133.2l28.9-2.5l-2.6-29.5c-1.2-14.3-2.8-27.6-4.1-38.6c3.8,10.2,10.6,26.5,16,37.9l15.5,32.2l9.6-34.4 c3.5-12.2,7.2-29.4,9.1-40.1c0.4,11.5,1.4,24.4,2.6,38.7l2.6,29.5l28.7-2.5L273,124.7z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M336.3,142.5h-33L268.5,277h33l4.8-25h26.5l5,25h33L336.3,142.5z M311.6,225.9l0.8-4.2 c3.3-17.9,6-32.5,7.1-44.8c1.3,12.3,4.2,26.9,7.3,44.6l0.8,4.4H311.6z"
});

var _ref21 = /*#__PURE__*/React.createElement("polygon", {
  className: "st5",
  points: "373.4,472.9 364.1,475.1 363,519.4 372.3,517.1 "
});

var _ref22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_5_",
  width: 462,
  height: 669.8
}));

var _ref23 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M317.5,530.4l5.3-1.3l-11-41.2l-12.5,3L286,538l5.7-1.4c0,0,3.4-0.8,4.5-4.7c0.7-2.5,1.4-4.9,1.4-4.9l14.3-3.5 c0,0,0.7,2.4,1.2,4.3C313.9,531.3,317.5,530.4,317.5,530.4 M309.8,515.9l-10,2.4l4-14.8c0.5-1.9,1.1-4.2,1.1-5.7l0.6-0.1 c0,1.5,0.4,3.5,0.9,5.2L309.8,515.9z"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M409.7,508.1l5.3-1.3l-11-41.2l-12.5,3l-13.4,47.1l5.7-1.4c0,0,3.4-0.8,4.5-4.7c0.7-2.5,1.4-4.9,1.4-4.9 l14.3-3.5c0,0,0.7,2.4,1.2,4.3C406,508.9,409.7,508.1,409.7,508.1 M402,493.6l-10,2.4l4-14.8c0.5-1.9,1.1-4.2,1.1-5.7l0.6-0.1 c0,1.5,0.5,3.5,0.9,5.2L402,493.6z"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M244,548.2l-9.4-11c5.5-3.6,8.4-9.2,8.6-16.4c0.3-10.9-5.9-15-15.5-12.7l-18,4.4l-1.1,44.1l9.7-2.4l0.3-10.9 l6.5-1.6c0,0,5.6,6.1,6.4,7.2c1.6,2,4.3,1.2,4.3,1.2L244,548.2z M233.9,523.5c-0.1,5.9-2.9,8-7.8,9.2l-7.3,1.8l0.4-16.2l7.8-1.9 C232,515.2,234,518.4,233.9,523.5"
});

var _ref26 = /*#__PURE__*/React.createElement("polygon", {
  className: "st5",
  points: "252.6,502.1 251.5,546.4 279.2,539.7 278.5,531.6 261,535.9 261.2,527.6 276.4,523.9 276.6,515.7  261.4,519.4 261.7,508.1 278.6,504 278.8,495.8 "
});

var _ref27 = /*#__PURE__*/React.createElement("polygon", {
  className: "st5",
  points: "330.2,483.3 329.1,527.6 356.7,520.9 356,512.7 338.7,516.9 339.5,481.1 "
});

function SvgOmaKotiLogoRealiaIsannointi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 462 669.8",
    style: {
      enableBackground: "new 0 0 462 669.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, /*#__PURE__*/React.createElement("g", null, _ref10, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _ref11, _ref12), _ref13, _ref14, _ref15, _ref16, /*#__PURE__*/React.createElement("g", null, _ref17, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _ref18, _ref19, _ref20), _ref21, /*#__PURE__*/React.createElement("g", null, _ref22, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _ref23, _ref24, _ref25), _ref26, _ref27);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmaKotiLogoRealiaIsannointi);
export default __webpack_public_path__ + "static/media/omaKotiLogoRealiaIsannointi.60a3b19445fb52431f4895aaec2c04b4.svg";
export { ForwardRef as ReactComponent };